import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import AppointmentsRequestsCard from "../../../../components/requests/AppointmentsRequestsCard";
import OutGoingRequestAppointmentCard from "../../../../components/requests/OutGoingRequestAppointmentCard";
import { makeApiRequest } from "../../../../helpers";
import { updateChangeScheduleRequests } from "../../../../api/endpoints/tutors/requests";
import { ApiResponse } from "../../../../api/apiResponse";
import RequestsModel from "../../../../api/models/RequestsModel";
import { ToastContext } from "../../../../App";
type ReceivedTabProps = {
  requests: RequestsModel[];
  oldRequests: RequestsModel[];
};
export const ReceivedTab = (props: ReceivedTabProps) => {
  const { requests, oldRequests } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const toast = useContext(ToastContext);

  const changeRequestStatus = (accept: boolean, id: string | number) => {
    if (accept) {
      makeApiRequest(
        () => updateChangeScheduleRequests(id, { status: "approved" }),
        (response: ApiResponse) => {
          if (response.isSuccess) {
            toast?.success(t("savedSuccessfully"));
            window.location.reload();
          } else {
            response.errorMessages.forEach((errorMessage) => {
              toast?.error(errorMessage);
            });
          }
        }
      );
    } else {
      makeApiRequest(
        () => updateChangeScheduleRequests(id, { status: "rejected" }),
        (response: ApiResponse) => {
          if (response.isSuccess) {
            toast?.success(t("savedSuccessfully"));
            window.location.reload();
          } else {
            response.errorMessages.forEach((errorMessage) => {
              toast?.error(errorMessage);
            });
          }
        }
      );
    }
  };

  return (
    <div className="flex flex-col w-full gap-6 px-8 py-6 bg-white">
      <div className="flex flex-col">
        {requests.length > 0 && (
          <>
            <h3 className="text-lg font-medium leading-6 text-gray-700 ">
              {t("newRequests")}
            </h3>
            <div className="flex flex-col gap-3">
              {requests.map((request) => {
                if (request?.userType !== "candidate")
                  return (
                    <AppointmentsRequestsCard
                      request={request}
                      changeRequestStatus={changeRequestStatus}
                      showModal={true}
                      owner={true}
                    />
                  );
              })}
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col">
        {oldRequests.length > 0 && (
          <>
            <h3 className="text-lg font-medium leading-6 text-gray-700 ">
              {t("oldRequests")}
            </h3>
            <div className="flex flex-col gap-3">
              {oldRequests.map((request) => (
                <OutGoingRequestAppointmentCard request={request} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
